export class Country {
  code: string;
  nameDE: string;
  nameEN: string;
  nameFR: string;
  nameNL: string;
}
